import { useState, useEffect } from "react";
import { IImportar } from "../../interfaces/IImportar";
import Swal from 'sweetalert2';
import ImportarNovoModalRegimeTabela from "./ImportarNovoModalRegimeTabela";

const ImportarNovoModalRegime = () => {
 
    // const [eventos, setEventos] = useState<IImportar[]>([]);
    const [regrasExibicao, setRegrasExibicao] = useState<IImportar[]>([]);
    // const [eventoVM, setEventoVM] = useState<IImportar>({} as IImportar);
    // const [tituloModal, setTituloModal] = useState<string>('');
    // const [carregado, setCarregado] = useState<boolean>(false);
    const columns = [
        {
            name: 'Regime Tributário',
            selector: (row: IImportar) => row['nome'],
            sortable: true,
        },
        {
            name: 'Ano de opção',
            selector: (row: IImportar) => row['ano'],
            sortable: true,
        },
        {
            name: 'Data de registro',
            selector: (row: IImportar) => row['data'],
            sortable: true,
        },
        {
            name: 'Ações',
            cell: (row: IImportar) => <AcoesRegras excluirDocumentos={excluirDocumentos} editarDocumentos={(regras: IImportar) => {
                // setTituloModal('Editar Tipo de Documentos');
                // setEventoVM(regras);
            }} item={row} />
        }
    ];
    const AcoesRegras = ({ item, excluirDocumentos, editarDocumentos }: { item: IImportar, excluirDocumentos: (regras: IImportar) => void, editarDocumentos: (Regras: IImportar) => void }) => {
        return <div data-tag="allowRowEvents">
            <i onClick={() => { editarDocumentos(item) }} className="fas fa-edit fa-lg" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }}></i>
            <i onClick={() => { excluirDocumentos(item) }} className="fas fa-trash-alt fa-lg" style={{ color: '#5E6397', marginLeft: '25px', fontWeight: 'normal', cursor: 'pointer' }}></i>
        </div>
    }

    useEffect(() => {
        async function obterTodasRegrasIniciais() {
            try {
                //TODO: ??? Verificar.
                // var todosEventos = await ImportarService.obterTodos();
                // setEventos(todosEventos);
                // setRegrasExibicao(todosEventos);
            } catch (error) {
                console.log('Não foi possivel carregar os documentos iniciais')
            }
        }

        setTimeout(() => {
            obterTodasRegrasIniciais();
        }, 100)
    }, []);

    async function excluirDocumentos(regras: IImportar) {
        try {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-modal-excluir ms-5',
                    cancelButton: 'btn btn-modal-cancelar'
                },
                buttonsStyling: false
            });

            let result = await swalWithBootstrapButtons.fire({
                title: 'Excluir Documentos',
                text: `Você realmente deseja excluir esse documento?`,
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: `Excluir`,
                reverseButtons: true
            });

            if (result.isConfirmed) {
                // await ImportarService.excluir(regras.id);

                setRegrasExibicao(regrasExibicao.filter(e => e.id !== regras.id));

                await Swal.fire({
                    title: '',
                    text: 'Excluido',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 3000,
                })
            }
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        }
    }

    // async function salvar(evento: IImportar) {
    //     if (evento.id !== undefined && evento.id !== null) {
    //         editarDocumentos()
    //     } else {
    //         adicionarDocumentos(evento);
    //     }
    // }

    // async function editarDocumentos() {
    //     try {
    //         await Swal.fire({
    //             text: 'Documentos foi editada com sucesso',
    //             timer: 4000,
    //             icon: 'success',
    //             showConfirmButton: false
    //         });
    //     } catch (error: any) {
    //         Swal.fire({
    //             text: error.message,
    //             timer: 4000,
    //             icon: 'error',
    //             showConfirmButton: false
    //         });
    //     }
    // }

    // async function adicionarDocumentos(evento: IImportar) {
    //     try {
    //         await Swal.fire({
    //             text: 'Documentos foi adicionada com sucesso',
    //             timer: 4000,
    //             icon: 'success',
    //             showConfirmButton: false
    //         });
    //     } catch (error: any) {
    //         Swal.fire({
    //             text: error.message,
    //             timer: 4000,
    //             icon: 'error',
    //             showConfirmButton: false
    //         });
    //     }
    // }

    return <div style={{ border: '1px solid #ddd', borderRadius: '5px', padding: '10px', minHeight: '505px' }}>
        <div style={{display: 'flex', paddingBottom: '30px'}}>
            <div className="col-md-5">
                <label htmlFor="form-mensagem-tipo" className="form-label required">Regime Tributário</label>
                <select style={{backgroundColor: 'white'}} disabled placeholder="Selecione" className="form-select" id="form-mensagem-tipo"   >
                    <option>Selecione</option>
                </select>
            </div>
            <div className="col-md-2">
                <label htmlFor="form-mensagem-tipo" className="form-label required">Ano de opção</label>
                <select style={{backgroundColor: 'white'}} disabled placeholder="0000" className="form-select" id="form-mensagem-tipo"   >
                    <option>Selecione</option>
                </select>
            </div>
            <button style={{height: '40px', marginTop: '27px'}} className='btn btn-sm btn-primario'><i className="icon-lg text-white fas fa-plus"></i></button>
        </div>
        {
            //carregado ?
                <ImportarNovoModalRegimeTabela colunas={columns} itens={regrasExibicao} />
            //:
            //    <p>Carregando...</p>
        }
    </div>
};

export default ImportarNovoModalRegime;